module.exports = __webpack_public_path__ + "static/media/ic-gridview.b8e602e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-gridview.svg
// module id = 627
// module chunks = 14